import React from "react";
const initial = {
    data: {},
    updateGrafosData: () => { },
    resetObjects: () => { },
};
export const GraphDataContext = React.createContext(initial);
export const GraphDataProvider = ({ initialData, children, }) => {
    const [data, setData] = React.useState(initialData);
    React.useEffect(() => {
        setData(initialData);
    }, [initialData]);
    const updateGrafosData = React.useCallback((newData) => {
        setData(newData);
    }, []);
    const resetObjects = React.useCallback(() => {
        const newData = {
            data: Object.assign({}, data.data),
            objects: [],
        };
        setData(newData);
    }, []);
    const value = { data, updateGrafosData, resetObjects };
    return (React.createElement(GraphDataContext.Provider, { value: value }, children));
};
//# sourceMappingURL=index.js.map